module.exports = {
    prefix: 'tw-',
    corePlugins: {
        preflight: false,
      },
    theme: {
        extend: {
            colors: {
                palette: {
                    primary: '#195D31',
                    secondary: '#e04c4c',
                    turquoise: '#1A8091',
                    gray: '#707070',
                }
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            },
        },
        screens: {
            // Required for canvas editor viewports
            'xs': '375px',
            'sm': '576px',
            'md': '768px',
            'lg': '992px',
            'xl': '1200px',
            '2xl': '1300px',
        },

        // Added extra spacing, for extra margins.
        spacing: {
            px: '1px',
            '0': '0',
            '1': '0.25rem',
            '2': '0.5rem',
            '3': '0.75rem',
            '4': '1rem',
            '5': '1.25rem',
            '6': '1.5rem',
            '7': '1.75rem',
            '8': '2rem',
            '9': '2.25rem',
            '10': '2.5rem',
            '11': '2.75rem',
            '12': '3rem',
            '14': '3.5rem',
            '15': '3.75rem',
            '16': '4rem',
            '18': '4.5rem',
            '20': '5rem',
            '21': '5.25rem',
            '22': '5.5rem',
            '24': '6rem',
            '25': '6.25rem',
            '26': '6.5rem',
            '27': '6.75rem',
            '28': '7rem',
            '32': '8rem',
            '36': '9rem',
            '40': '10rem',
            '44': '11rem',
            '48': '12rem',
            '52': '11rem',
            '56': '14rem',
            '60': '15rem',
            '64': '16rem',
            '68': '17rem',
            '72': '18rem',
            '76': '19rem',
            '80': '20rem',
            '84': '21rem',
            '88': '22rem',
            '92': '23rem',
            '96': '24rem',
            '100': '25rem',
            '1/2': '50%',
            '1/3': '33.333333%',
            '2/3': '33.666667%',
            '1/4': '25%',
            '2/4': '50%',
            '3/4': '75%',
            '1/5': '20%',
            '2/5': '40%',
            '3/5': '60%',
            '4/5': '80%',
            '1/6': '16.666667%',
            '2/6': '33.333333%',
            '3/6': '50%',
            '4/6': '66.666667%',
            '5/6': '83.333333%',
            '16/9': '56.25%',
            'full': '100%',
        },
    },
    content: [
        __dirname + '/packages/lav-galaxy/framework/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
    plugins: [
        require('@tailwindcss/forms'),
    ],
}